export const UPDATE_FILTERS = "UPDATE_FILTERS";
export const SELECT_FILTER_OPTION = "SELECT_FILTER_OPTION";
export const UPDATE_CURRENT_PAGE = "UPDATE_CURRENT_PAGE";
export const REQUEST_SEARCH_RESULTS = "REQUEST_SEARCH_RESULTS";
export const RECEIVE_SEARCH_RESULTS = "RECEIVE_SEARCH_RESULTS";
export const CHANGE_SEARCH_RESULT_PAGE = "CHANGE_SEARCH_RESULT_PAGE";
export const MOST_RECENT_CATALOG_URL = "MOST_RECENT_CATALOG_URL";

const actions = {
  /**
   * UPDATE_FILTERS action creator.
   *
   * Update filters in the state
   *
   * @param {Object} payload
   */
  updateFilters({ doorType, filterOptions = [], page = 1, pathPrefix }) {
    return {
      type: UPDATE_FILTERS,
      payload: { doorType, filterOptions, page, pathPrefix }
    };
  },
  /**
   * SELECT_FILTER_OPTION action creator.
   *
   * Doesn't mutate the state. Used for Google Analytics.
   *
   * @param {Object} option Filter option.
   */
  selectFilterOption({ filter, option }) {
    return {
      type: SELECT_FILTER_OPTION,
      payload: { filter, option }
    };
  },
  /**
   * CHANGE_SEARCH_RESULT_PAGE action creator.
   *
   * Purely for tracking and passing data to the saga.
   *
   * @param {Object} payload
   */
  changePage({ doorType, filterOptions, page, pathPrefix }) {
    return {
      type: CHANGE_SEARCH_RESULT_PAGE,
      payload: { doorType, filterOptions, page, pathPrefix }
    };
  }
};

export default actions;
